import { useMemo } from "react";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { Option } from "modules/Channel/configs/constant";

export const useOptions = (data, label = "name", value = "id") => {
  return useMemo(() => {
    // if (!!data && !_.isEmpty(data) && !_.isArray(label)) {
    //   return _.map(data, (x) => {
    //     let rs = { label: _.get(x, label), value: _.get(x, value) };
    //     return rs;
    //   });
    // }
    // if (!!data && !_.isEmpty(data) && _.isArray(label)) {
    //   return _.map(data, (x) => {
    //     const labelConcat = Object.values(_.pick(x, label)).join(" - ");
    //     let rs = { label: labelConcat, value: _.get(x, value) };
    //     return rs;
    //   });
    // }

    if (!!data && !_.isEmpty(data)) {
      return _.map(data, (x) => {
        const _label = _.isArray(label)
          ? Object.values(_.pick(x, label)).join(" - ")
          : _.get(x, label);
        let rs = { label: _label, value: _.get(x, value) };
        return rs;
      });
    }

    return [];
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [data]);
};

export const useOptionsFromEnum = (data, isKeyLabel) => {
  return useMemo(() => {
    return !!data && !_.isEmpty(data)
      ? !isKeyLabel
        ? Object.entries(data).map(([key, value]) => {
            return {
              value: key,
              label: value,
            };
          })
        : Object.entries(data).map(([key, value]) => {
            return {
              value: value,
              label: key
                .split("_")
                .map((item) => {
                  return (
                    item.charAt(0).toUpperCase() +
                    item.substring(1).toLowerCase()
                  );
                })
                .join(" "),
            };
          })
      : [];
  }, [data, isKeyLabel]);
};

// export const useOptionsFromPagination = (data) => {
//   return useMemo(() => {
//     return !!data && !_.isEmpty(data)
//         ? Object.entries(data).map(([key, value]) => {
//             return {
//               value:Number(key) ,
//               label: value,
//             };
//           }):[]
//   }, [data]);
// };

export const useOptionsStatusFromEnum = (data, isKeyLabel) => {
  return useMemo(() => {
    return !!data && !_.isEmpty(data)
      ? !isKeyLabel
        ? Object.entries(data).map(([key, value]) => {
            return {
              value: key,
              label: value,
            };
          })
        : Object.entries(data).map(([key, value]) => {
            const _key =
              key.split("_")[2].charAt(0).toUpperCase() +
              key.split("_")[2].substring(1).toLowerCase();
            return {
              value: value,
              label: _key,
            };
          })
      : [];
  }, [data, isKeyLabel]);
};

export const useOptionsEnumTranslate = (props) => {
  const { data, isKeyLabel, hasOptionALL = true } = props;
  const { t } = useTranslation("uaa");

  return useMemo(() => {
    let listOptions =
      !!data && !_.isEmpty(data)
        ? !isKeyLabel
          ? Object.entries(data).map(([key, value]) => {
              return {
                value: key,
                label: t(`options.enum.${key}`),
              };
            })
          : Object.entries(data).map(([key, value]) => {
              return {
                value: value,
                label: t(
                  `options.enum.${key
                    .split("_")
                    .map((item) => {
                      return (
                        item.charAt(0).toUpperCase() +
                        item.substring(1).toLowerCase()
                      );
                    })
                    .join(" ")}`
                ),
              };
            })
        : [];

    if (hasOptionALL) {
      listOptions = [
        ...listOptions,
        { label: t(`options.${Option.ALL}`), value: "ALL" },
      ];
    }

    return listOptions;
  }, [data, isKeyLabel, t]);
};

// Use to translate options get via server
export const useOptionsTranslate = (props) => {
  const {
    data,
    label = "name",
    value = "id",
    additionalFields,
    hasOptionALL = true,
    translateOption = false,
  } = props;
  const { t } = useTranslation("uaa");

  return useMemo(() => {
    if (!!data && !_.isEmpty(data)) {
      let listOptions = _.map(data, (x) => {
        let rs = {
          label: translateOption
            ? t(`options.${_.get(x, label)}`)
            : _.get(x, label),
          value: _.get(x, value),
        };

        if (!!additionalFields) {
          _.forEach(additionalFields, (f) => {
            rs = { ...rs, [f]: _.get(x, f) };
          });
        }

        return rs;
      });

      if (hasOptionALL) {
        listOptions = [
          ...listOptions,
          { label: t(`options.${Option.ALL}`), value: "ALL" },
        ];
      }

      return listOptions;
    }

    return [];
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [data, t]);
};

export const useOptionsWithDefault = (data, label = "name", value = "id", defaultProperty = "isDefault") => {
  return useMemo(() => {
    let options = [];
    let defaultOption = null;
    
    // Process data and find the default item (if any)
    if (!!data && !_.isEmpty(data)) {
      // First, process all items into options format
      const dataOptions = _.map(data, (x) => {
        const _label = _.isArray(label)
          ? Object.values(_.pick(x, label)).join(" - ")
          : _.get(x, label);
        const option = { label: _label, value: _.get(x, value) };
        
        // If this item has isDefault=true, save it as the default option
        if (x.hasOwnProperty(defaultProperty) && x[defaultProperty] === true) {
          defaultOption = option;
        }
        
        return option;
      });
      
      // Put the default option at the beginning if found
      if (defaultOption) {
        options = [defaultOption, ...dataOptions.filter(opt => opt !== defaultOption)];
      } else {
        options = dataOptions;
      }
    }

    return options;
  }, [data, label, value]);
};

